import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ sponsor, onEditClicked, onDeleteClicked }) => (
  <tr>
    <td>{sponsor.sponsor?.sponsorName || ''}</td>
    <td>{sponsor.effectiveDate ? formatDate(sponsor.effectiveDate) : ''}</td>
    <td>{sponsor.expirationDate ? formatDate(sponsor.expirationDate) : ''}</td>
    <td className='pull-right'>
      <button className={global.IconButtonMargin} type="button" onClick={(e) => onEditClicked(e, sponsor)}>
        <EditIcon />
      </button>
      <button className={global.IconButtonMargin} type="button" onClick={(e) => onDeleteClicked(e, sponsor)}>
        <DeleteIcon />
      </button>
    </td>
  </tr>
);

const SponsorsGridLarge = ({ gridData, isLoading, onEditClicked, onDeleteClicked }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Sponsor Name</th>
        <th>Effective Date</th>
        <th>Expiration Date</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true
        ? <tr><td colSpan="4">Loading...</td></tr>
        : Array.isArray(gridData) && gridData.length > 0
          ? gridData.map((sponsor, i) => <GridRow key={i} sponsor={sponsor} onEditClicked={onEditClicked} onDeleteClicked={onDeleteClicked} />)
          : <tr><td colSpan="4">No Sponsors</td></tr>
      }
    </tbody>
  </table>
);

export default SponsorsGridLarge;